import React from 'react';


export default ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <path fill={color || '#0092e5'} d="M5357.48,923.978h-4.4v-4.4a1.3,1.3,0,0,0-2.6,0v4.4h-4.4a1.3,1.3,0,0,0,0,2.6h4.4v4.4a1.3,1.3,0,1,0,2.6,0v-4.4h4.4a1.3,1.3,0,1,0,0-2.6Z" transform="translate(-5344.781 -918.278)"/></svg>
  )
}